import {
  Component, Input, OnChanges, OnInit, SimpleChange
} from '@angular/core';
import {
  UntypedFormBuilder, UntypedFormGroup, Validators
} from '@angular/forms';

import type { Favorite } from 'models/favorites.model';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-edit-favorite',
  templateUrl: './edit-favorite.component.html',
  styleUrls: ['./edit-favorite.component.scss']
})
export class EditFavoriteComponent implements OnInit, OnChanges {
  @Input() favorite!: Favorite;

  form!: UntypedFormGroup;

  formReady = false;

  constructor(
    protected fb: UntypedFormBuilder,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.storeService.setFormReady(this.formReady);

    this.form = this.fb.group({
      name: [this.favorite ? this.favorite.title : '', [Validators.required, Validators.minLength(1)]]
    }, { updateOn: 'blur' });

    this.formReady = true;
    this.storeService.setFormReady(this.formReady);
  }

  ngOnChanges(changes: { favorite?: SimpleChange }): void {
    if (this.form && changes && changes.favorite) {
      this.favorite = changes.favorite.currentValue;
      this.form.controls.name.setValue(this.favorite.title, { emitEvent: false });
    }
  }
}
